module.exports = __webpack_public_path__ + "static/assets/b90cc1cc7baaf6838517114af748ccd4.png";